import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, size = 28, readOnly = false, testIdPrefix = "star" }) {
  return (
    <div className="flex items-center gap-1.5" data-testid={`${testIdPrefix}-rating`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= value;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange?.(n)}
            className={
              "transition-transform " +
              (readOnly ? "cursor-default" : "hover:scale-110 active:scale-95 cursor-pointer")
            }
            data-testid={`${testIdPrefix}-${n}`}
            aria-label={`${n} von 5 Sternen`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              className={filled ? "fill-brand-lighter text-brand-lighter" : "fill-transparent text-zinc-700"}
            />
          </button>
        );
      })}
    </div>
  );
}
